export default __webpack_public_path__ + "static/1_3-f836d4717d2e12c720125b3449a46fb8.jpeg";